<template>
	<div class="agent__container">
    <div class="agent__info" v-if="agent.PhoneNumber.AreaCode">
      <p class="agent__byline">For more information on your enrollment, contact your agent:</p>
      <address>
        <div class="agent__name">{{agent.Name}}</div>
        <div class="agent__phone">{{ (agent.PhoneNumber.AreaCode + agent.PhoneNumber.Number).replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3") }}</div>
      </address>
    </div>
    <div class="agent__unavailable" v-else>
      For more information on your enrollment, contact your HR representative.
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'agent-info',
	props: {
	},
  computed: {
    ...mapGetters({
      agent: 'getAgent'
    })
  }
}
</script>
<style lang="scss" scoped>
.agent {
  &__info, &__unavailable {
    color: $gray;
    font-weight: normal;
    line-height: 1.2;
    font-size: 1rem;
  }
  &__name, &__phone {
    font-style: normal;
  }
  &__name {
    font-weight: bold;
  }
  &__byline {
    margin: 0 0 .67em;
    line-height: 1.2;
  }
}
</style>
